import React from "react";

function StaffNurse() {
    const staffNurse = [
        {
            heading: "Staff Nurse",
        },
        {
            name: "Mrs. Pakala Nagamani",
            position1: "Staff Nurse Grade-I",
            image: "https://files.iittp.ac.in/images/demo/iit/Staff/nagamani.png",
        },
        {
            name: "Mr. J Sesha Naidu",
            position1: "Staff Nurse Grade-I",
            image: "https://files.iittp.ac.in/images/demo/iit/Staff/seshanaidu.jpg",
        },
        {
            name: "Mr. Praveen P",
            position1: "Junior Nursing Officer",
            image: "https://files.iittp.ac.in/images/demo/iit/Staff/Praveen_P_JNO.png",
        },
    ];

    return (
        <>
            {staffNurse.map((nurse, index) =>
                nurse.heading ? (
                    <h2 className="mb-3" key={index}>
                        {nurse.heading}
                    </h2>
                ) : (
                    <div key={index} className="col-xl-4 col-md-8">
                        <div className="single-team mb-40">
                            <div className="team-thumb">
                                <div className="brd">
                                    <img src={nurse.image} alt="img" />
                                </div>
                            </div>
                            <div className="team-info">
                                <h4>{nurse.name}</h4>
                                <div className="text-dark">
                                    <p>{nurse.position1}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            )}
        </>
    );
}

export default StaffNurse;
